import blue from "./blue.css";
import overlay from "./overlay.css";
import white from "./white.css";

export default { blue, overlay, white };
